import { TeamPlayerElement, TeamPlayerStat } from '../types';

export const convertElementToPlayerValue = (stat: TeamPlayerElement): TeamPlayerStat => {
  switch (stat) {
    case 'age':
      return 'playerAge';
    case 'matches_played':
      return 'played';
    case 'minutes':
      return 'minutes';
    case 'yellow_cards':
      return 'yellowCards';
    case 'red_cards':
      return 'redCards';
    case 'goals':
      return 'goals';
    case 'assists':
      return 'assists';
    case 'goals_substitute':
      return 'goalsSubstitute';
    case 'minutes_substitute':
      return 'minutesSubstitute';
    case 'started':
      return 'started';
    case 'substitute_in':
      return 'substituteIn';
    case 'substitute_out':
      return 'substituteOut';
    case 'cleansheets':
      return 'cleansheets';
    case 'conceded':
      return 'conceded';
    default:
      return stat;
  }
};
